import React from "react";
import { motion } from "framer-motion";
import { CLIENTS_IMAGE } from "../../data/hseData";

export const Clients = () => (
  <section id="clientes" data-testid="section-clientes" className="relative py-24 bg-white border-y border-[#E4E7EB]">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-3 mb-4">
          <span className="w-8 h-px bg-[#2FA36B]" />
          <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">Clientes</span>
          <span className="w-8 h-px bg-[#2FA36B]" />
        </div>
        <h2 className="font-condensed font-bold uppercase text-3xl sm:text-4xl lg:text-5xl text-[#0F2A44] leading-[0.95] tracking-tight">
          Confiança de <span className="text-[#2FA36B]">grandes indústrias</span>
        </h2>
        <p className="mt-4 text-[#6B7785] font-body text-base max-w-2xl mx-auto">
          Ao longo de 20 anos, apoiamos operações críticas em algumas das maiores companhias do Brasil.
        </p>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-5xl mx-auto"
      >
        <img src={CLIENTS_IMAGE} alt="Clientes atendidos pela HSE" className="w-full h-auto" data-testid="clients-grid" />
      </motion.div>
    </div>
  </section>
);

export default Clients;
